/**
 * <s-footer-accordion> wraps one footer <details>. Below the md breakpoint it
 * starts closed and behaves as a normal accordion; from md up it stays open
 * so the desktop column always shows its links.
 *
 * Markup renders the <details> with `open`, so desktop and no-JS visitors see
 * the links without any layout shift.
 */
class SFooterAccordion extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.desktopQuery = window.matchMedia('(min-width: 48rem)');
    this.sync = () => {
      this.details.open = this.desktopQuery.matches;
    };
    this.keepOpenOnDesktop = () => {
      if (this.desktopQuery.matches && !this.details.open) this.details.open = true;
    };

    this.sync();
    this.desktopQuery.addEventListener('change', this.sync);
    this.details.addEventListener('toggle', this.keepOpenOnDesktop);
  }

  disconnectedCallback() {
    this.desktopQuery?.removeEventListener('change', this.sync);
    this.details?.removeEventListener('toggle', this.keepOpenOnDesktop);
  }
}

if (!customElements.get('s-footer-accordion')) {
  customElements.define('s-footer-accordion', SFooterAccordion);
}
